
import { Vue, Component, Prop } from 'vue-property-decorator';
import * as echarts from 'echarts';
import lazyInject from '@/di';
import Loading from '@/components/loading/index.vue';
import WorkbenchesService from '@/services/workbenches.service';

@Component({
  components: {
    Loading,
  },
})
export default class StatisticsMod extends Vue {
  typeLoading: any = false;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  @Prop({ type: Array, default: [] })
  userModule?: any;

  data = '';

  chartText: any = {
    ad_campaign_recharge: {
      title: '推广通充值完成率',
      name: '推广通目标',
      realFinishedAll: '已完成金额',
      ratio: '完成率',
      chartA: 'name',
      chartB: 'target_quota_all',
      chartC: 'real_finished_all',
      chartD: 'ratio',
      attribute: '金额',
      unit: '元',
    },
    ad_campaign_cost: {
      title: '推广通消耗率完成率',
      name: '充值金额',
      realFinishedAll: '消耗金额',
      ratio: '消耗占比',
      chartA: 'name',
      chartB: 'target_quota_all',
      chartC: 'real_finished_all',
      chartD: 'ratio',
      attribute: '金额',
      unit: '元',
    },
    agent_gmv: {
      title: '核销GMV完成率',
      name: 'GMV目标',
      realFinishedAll: '已完成GMV',
      ratio: '完成率',
      chartA: 'name',
      chartB: 'target_quota',
      chartC: 'gmv',
      chartD: 'ratio',
      attribute: '金额',
      unit: '元',
    },
    activity_sign_cps: {
      title: 'CPS标品招商完成率',
      name: '目标',
      realFinishedAll: '已完成',
      ratio: '完成百分比',
      chartA: 'name',
      chartB: 'target_quota',
      chartC: 'shop_num',
      chartD: 'ratio',
      attribute: '数量',
      unit: '个',
    },
    activity_sign_service: {
      title: '洗车节活动招商完成率',
      name: '目标',
      realFinishedAll: '已完成',
      ratio: '完成百分比',
      chartA: 'name',
      chartB: 'target_quota',
      chartC: 'num',
      chartD: 'ratio',
      attribute: '数量',
      unit: '个',
    },
  };

  async init(val: any) {
    this.data = val;
    const res = await this.workbenchesService.getDashboard();
    for (const keyAll in res) {
      if (keyAll) {
        const data = res[keyAll];
        const chartArr: any = {
          targetQuotaAll: [],
          realFinishedAll: [],
          name: [],
          ratio: [],
        };
        for (const key in data) {
          if (key) {
            chartArr.targetQuotaAll.push(Number(data[key][this.chartText[keyAll]?.chartB]));
            chartArr.realFinishedAll.push(Number(data[key][this.chartText[keyAll]?.chartC]));
            chartArr.name.push(data[key][this.chartText[keyAll]?.chartA]);
            chartArr.ratio.push((Number(data[key][this.chartText[keyAll].chartD]) * 100).toFixed(2));
          }
        }
        setTimeout(() => {
          this.typeLoading = true;
          setTimeout(() => {
            this.setChartData(chartArr, keyAll);
          }, 1000);
        }, 1000);
      }
    }
  }
  // 其他方法...
  // 完成组件的其他逻辑...
  setChartData(data: any, key: any) {
    const option = {
      title: {
        text: this.chartText[key].title,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
        formatter: (params: any) => {
          let result = `<b>${params[0].name}</b><br/>`;
          params.forEach((item: any) => {
            const unit = item.seriesIndex === 2 ? '%' : this.chartText[key].unit;
            result += `${item.marker} ${item.seriesName}: <b>${item.value}${unit}</b><br/>`;
          });
          return result;
        },
      },
      legend: {
        bottom: 10,

      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: data.name,
        axisLabel: {
          // rotate: 30, // 倾斜角度，0-90度
          margin: 10, // 标签与轴线的距离
          interval: 0, // 强制显示所有标签
          // 其他样式设置
          color: '#666',
          fontSize: 12,
        },
      },
      yAxis: [
        {
          type: 'value',
          scale: true,
          name: this.chartText[key].attribute,
          min: 0,
          splitLine: {
            show: false, // 不显示右侧轴的网格线
          },
        },
        {
          type: 'value',
          scale: true,
          name: '占比',
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: '{value} %',
          },
          splitLine: {
            show: false, // 不显示右侧轴的网格线
          },
        },
      ],
      series: [
        {
          name: this.chartText[key].name,
          data: data.targetQuotaAll,
          type: 'bar',
        },
        {
          name: this.chartText[key].realFinishedAll,
          data: data.realFinishedAll,
          type: 'bar',
        },
        {
          name: this.chartText[key].ratio,
          type: 'bar',
          data: data.ratio,
          yAxisIndex: 1,
        },
      ],
    };
    // 设置图表数据
    const chart: any = document.getElementById(key);
    const myChart = echarts.init(chart);
    myChart.setOption(option);
  }
}

